<template>
            <v-card>
                <div style="text-align:center">
                    <label style="font-size:30px; font-weight:bold">Favoritos</label>
                </div>
                <v-divider></v-divider>
                <v-layout justify-center v-if="favoriteslaundries.length >=5">
                    <v-flex xs11>
                        <v-text-field
                                v-model="inputsearchlaundries"
                                outline
                                label="Buscar"
                                append-icon="search"
                                @keyup="searchingfavoriteslaundries"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-card-text style="height: 300px;">
                    <div v-if="favoriteslaundries.length <=0">
                        <label>Elija tus lavanderias favoritas</label>
                    </div>
                    <!--card-product-->
                    <div v-if="favoriteslaundries.length >=1">
                        <div class="card-favorites" v-for="(arraysearchlaundries,i) in arraysearchlaundries" :key="i+1">
                            <img style="border-radius:100%; padding:10px; cursor:pointer" :src="arraysearchlaundries.image_company.length <= 0?'https://cdn.vuetifyjs.com/images/cards/foster.jpg' : arraysearchlaundries.image_company[0].link" @click="goprofilecompany(arraysearchlaundries)">
                            
                                <!--Product name-->
                            <div class="card-favorites-infos" @click="goprofilecompany(arraysearchlaundries)" style="cursor:pointer">
                                <h2>{{arraysearchlaundries.name}}</h2>
                                <p>{{arraysearchlaundries.address}}</p>
                            </div>
                            <div class="card-favorites-infos" style="margin-left:15px">
                                <label class="fas fa-trash" style="cursor:pointer" @click="deletefavoritelaundry(arraysearchlaundries)"></label>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <div class="text-right">
                    <v-btn color="primary" @click="modalfavoritescompany = false">SALIR</v-btn>
                </div>
            </v-card>
</template>
<script>
import initVue from '../../../helpers/initVue'
import { EventBus } from '../../../helpers/eventbus/event-bus'
import {FavoritesStorage} from '@/helpers/storage'
import {
    mapGetters,
    mapActions
} from 'vuex'
export default {
    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),

    data(){
        return{
            identity: null,
            session: false,
            token: null,
            userstorage: {},
            modalfavoritescompany: false,
            //n:100,
            arraysearchlaundries: [],
            inputsearchlaundries: '',
            favoriteslaundries : [],
            favoritesStorage:new FavoritesStorage(),
        }
    },

    created(){
        this.getidentity()
        if(this.inputsearchlaundries === ''){
                this.arraysearchlaundries = this.favoriteslaundries
        }

    },
    methods:{
        goprofilecompany(paramsarraycompany){
            this.listsearchopened = false
            this.$router.push({
                name: 'ProfileOfCompanies',
                params: { datacompany: paramsarraycompany._idcompany.ruc}
            })
            EventBus.$emit('getdatacompanybysearchinrucorname')
        },

        deletefavoritelaundry(d){
            //console.log(d._id)
            this.axios.delete(`users/deletefavoritecompanies/${d._idcompany}`)
            .then(res=>{
                //console.log(res)
                this.showusersfavoritelaundries()
                EventBus.$emit('showusersfavoritelaundries')
            })

        },
        /*
        choosingfavoritelaundry(){
            this.chossedfavoritecompany.namecompany=this.datalaundry[0].name
            this.chossedfavoritecompany.addresscompany=this.datalaundry[0].address
            this.chossedfavoritecompany.photocompany=this.datalaundry[0].photocompany
            //console.log(this.chossedfavoritecompany)
            this.axios.post(`users/choosefavoritecompany/${this.identity._id}/${this.token}/${this.datalaundry[0].idcompany}`, this.chossedfavoritecompany)
            .then(res=>{
                //console.log(res)
                this.showusersfavoritelaundries()
            })
            .catch(err=>{
                console.log(err)
            })
        },
        */

        showusersfavoritelaundries(){
            this.axios.get(`users/showfavoritecompanies/${this.identity._id}/${this.token}`)
            .then(res=>{
                this.arraysearchlaundries = []
                this.arraysearchlaundries = res.data.data.companies
                //console.log(this.arraysearchlaundries)
                this.favoriteslaundries = res.data.data.companies
                this.favoritesStorage.set(this.arraysearchlaundries);
                //console.log(tatahis.arraysearchlaundries)
                //console.log(this.favoriteslaundries)
            })
            .catch((err)=>{
                if(err.response==undefined){
                    return;
                }
                let mgserrorsession = err.response.data.message === 'error en inicio de sesión'
                if(mgserrorsession){
                    this.axios.get('user/logout/'+this.identity._id)
                    this.userstorage = {}
                    this.identity = null
                    this.token = null
                    localStorage.removeItem('iden')
                    localStorage.removeItem('user')
                    localStorage.removeItem('tok')
                    localStorage.clear
                    this.$store.dispatch('saveIdentity', null)
                    this.$store.dispatch('saveToken', null)
                    window.location = '/'
                }
            })
        },
        /* * Obteniendo la identidad para validar el token
 *******************************************************/
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            this.showusersfavoritelaundries()

            //console.log(this.session)
        },


        searchingfavoriteslaundries(){
            if(this.inputsearchlaundries === ''){
                this.showusersfavoritelaundries()
            }
            this.arraysearchlaundries = this.favoriteslaundries.filter((favoriteslaundries)=>{
                let regexsearch = new RegExp(this.inputsearchlaundries, 'ig')
                return favoriteslaundries.name.match(regexsearch)
            })
            

        }



    }
}
</script>
<style lang="scss">
    /*favorites name*/
    .card-favorites {
        overflow: hidden;
        height: 120px;
        background: white;
        box-shadow: 0 0 15px rgba(0,0,0,0.2);
        display: flex;
        align-items: center;
        margin-top: 20px
    }

    .card-favorites img {
        height: 80%;
        width: 100px;
        object-fit: cover;
    }

    .card-favorites h2 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
    }

    .card-favorites p {
        font-size: 12px;
        line-height: 1.4;
        opacity: .7;
        margin-bottom: 0;
        margin-top: 8px;
    }

    
</style>


